/* Enhances existing content only: no product mutations, extra requests or new claims. */
(() => {
  'use strict';
  function enhance(root) {
    const scopes = [...root.querySelectorAll('[data-dd-reading]')];
    if (root.matches?.('[data-dd-reading]')) scopes.unshift(root);
    for (const scope of scopes) {
      const content = scope.querySelector('[data-dd-content]');
      if (!content) continue;
      const toc = scope.querySelector('[data-dd-toc]');
      const headings = [...content.querySelectorAll('h2')].filter(h => h.textContent.trim());
      if (toc && headings.length >= 3) {
        const list = toc.querySelector('ol');
        list.replaceChildren();
        headings.forEach((heading, index) => {
          if (!heading.id) {
            const stem = (content.id || 'dd-content') + '-section-' + (index + 1);
            let id = stem, suffix = 1;
            while (document.getElementById(id)) id = stem + '-' + suffix++;
            heading.id = id;
          }
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.setAttribute('href', '#' + encodeURIComponent(heading.id));
          link.textContent = heading.textContent.trim();
          item.append(link); list.append(item);
        });
        toc.hidden = false; scope.classList.add('has-toc');
        const details = toc.querySelector('details');
        if (details && !details.dataset.ddReady) {
          details.open = !window.matchMedia?.('(max-width: 989px)').matches;
          details.dataset.ddReady = 'true';
        }
      } else if (toc) {
        toc.hidden = true; scope.classList.remove('has-toc');
      }
      content.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('dd-table-scroll')) return;
        let wrapper = table.parentElement;
        if (wrapper === content || wrapper.children.length !== 1 || wrapper.tagName !== 'DIV') {
          wrapper = document.createElement('div'); table.before(wrapper); wrapper.append(table);
        }
        wrapper.classList.add('dd-table-scroll'); wrapper.setAttribute('tabindex', '0');
        wrapper.setAttribute('role', 'region'); wrapper.setAttribute('aria-label', table.caption?.textContent || 'Product comparison table');
      });
      // Recognise the boxed product links already present in the approved content.
      content.querySelectorAll('.ddzmd-content > div').forEach(box => {
        const heading = box.querySelector(':scope > h3');
        const anchor = heading?.querySelector('a[href]');
        if (!anchor) return;
        let url;
        try { url = new URL(anchor.getAttribute('href'), window.location.origin); } catch { return; }
        if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/')) return;
        box.classList.add('dd-linked-card');
        if (box.querySelector(':scope > figure img')) box.classList.add('dd-linked-card--image');
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document), {once:true});
  else enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
